<template>
  <div class="map-container">
    <client-only>
      <l-map
        style="height: 100%"
        :zoom="2"
        :min-zoom="2"
        :center="[51.5285582, -0.2416784]"
      >
        <l-tile-layer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
        />
        <l-circle-marker
          v-for="(mapItem, index) in mapData"
          :key="index"
          :lat-lng="[mapItem.lat, mapItem.long]"
          :fill="true"
          :radius="calculateRadius(mapItem.count)"
          :fill-opacity="checkSubsAccess(mapItem) ? 1 : 0.9"
          :fill-color="
            checkSubsAccess(mapItem) ? circle.color : circle.colorRestricted
          "
          :color="
            checkSubsAccess(mapItem) ? circle.color : circle.colorRestricted
          "
          title="mapItem.name"
          @click="
            openPopUp(
              [mapItem.lat, mapItem.long],
              mapItem.name,
              mapItem.updates,
              mapItem.count,
              mapItem.tid,
              mapItem.subscribed,
              'circle'
            )
          "
        />
        <l-layer-group ref="features">
          <l-popup>
            <el-badge :value="popup.count" :max="10" class="map-badge mark">
              <h1>{{ popup.title }}</h1>
            </el-badge>
            <ul v-if="checkSubsAccess(popup, true)">
              <li
                v-for="(item, index) in popup.updates"
                :key="index"
                class="updates list"
              >
                <nuxt-link :to="item.url" target="_blank">
                  {{ item.name }}
                </nuxt-link>
              </li>
            </ul>
            <ul v-else>
              <li class="updates list">
                Please contact
                <a href="mailto:clientvalue@vixio.com">clientvalue@vixio.com</a>
                to activate this jurisdiction.
              </li>
            </ul>
          </l-popup>
        </l-layer-group>
      </l-map>
    </client-only>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkNewAccess, checkAccess } from "@/utils/constants";

export default {
  name: "Map",
  props: {
    mapData: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      markerLatLng: [47.31322, -1.319482],
      popup: {
        title: null,
        updates: [],
        count: 1,
        tid: 0,
        subscribed: 0
      },
      loading: false,
      show: true,
      enableTooltip: true,
      zoom: 6,
      center: [48, -1.219482],
      geojson: null,
      fillColor: "#e4ce7f",
      url: false,
      attribution: false,
      circle: {
        center: [47.41322, -1.0482],
        radius: 4500,
        color: "#37B8CB",
        colorRestricted: "#262053",
      },
    };
  },

  computed: {
    ...mapState("Auth", ["subscriptions"]),
    // This computed property does not seem to have any purpose.
    // However if for some reason the fetch results in an error there will be a kaboom.
    // Commenting out for now pending deletion.
    //
    // async created() {
    //   this.loading = true;
    //   const response = await fetch(
    //     "https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson"
    //   );
    //   const data = await response.json();
    //   this.geojson = data;
    //   this.loading = false;
    // },
  },
  mounted() {},
  methods: {
    rejectCoordinate(name, lat, long, subscribed) {
      return (lat === 0 && long === 0) || !subscribed;
    },
    openPopUp(latLng, title, updates, count, tid,subscribed, caller) {
      this.caller = caller;
      this.popup.title = title;
      this.popup.updates = updates;
      this.popup.count = count;
      this.popup.tid = tid;
      this.popup.subscribed = subscribed;
      this.$refs.features.mapObject.openPopup(latLng);
    },
    calculateRadius(count) {
      let rad = 0;

      if (count >= 1 && count <= 10) {
        rad = 1;
      }

      if (count > 10 && count <= 50) {
        rad = 2;
      }

      if (count > 50) {
        rad = 3;
      }
      return 5 * rad;
    },
    formatCoords(marker) {
      if (marker) {
        return [marker.lat, marker.lng];
      } else {
        return [0, 0];
      }
    },
    checkSubsAccess(item, test = false) {
      // determine whether they have new permissions or legacy
      let legacy = false;
      if (this.$store.state.Auth.subscriptions.legacy_permissions && this.$store.state.Auth.subscriptions.legacy_permissions.length > 0) {
        legacy = checkAccess(
          this.$store.state.Auth.subscriptions.legacy_permissions,
          "viewHorizonScanning",
          [item.tid]);

        return legacy;
      } else {
        return item.subscribed === 1;
      }


    },
    checkHsAccess(tid) {
      // return true;
      let legacy = true;
      let access = null;

      if (this.$store.state.Auth.subscriptions.legacy_permissions && this.$store.state.Auth.subscriptions.legacy_permissions.length > 0) {
        legacy = checkAccess(
          this.$store.state.Auth.subscriptions.legacy_permissions,
          "viewHorizonScanning",
          [tid]
        );
      }

      if (this.$store.state.Auth.subscriptions.permissions.restricted_jurisdictions && this.$store.state.Auth.subscriptions.permissions.restricted_jurisdictions.length > 0) {
        access = checkNewAccess(
          this.$store.state.Auth.subscriptions.permissions.restricted_jurisdictions,
          "hs",
          [tid]
        );
      }
      return legacy || access;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.map-container .list {
  border-bottom: 1px dashed #d3d3d3;
  padding-bottom: 2px;
}

.map-container {
  position: relative;
  height: 600px;
  margin-bottom: 2rem;

  .leaflet-popup-content-wrapper {
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    border-radius: 0px;
    width: 300px;
  }

  .leaflet-container {
    a {
      color: $link-primary;
      text-decoration: none;
      padding-bottom: 1rem;
      size: 0.8rem;
      &:hover {
        color: $link-primary-hover;
        text-decoration: underline;
      }
    }
  }
  .leaflet-popup-close-button {
    display: none;
  }
  .updates {
    .list {
      padding-bottom: 1rem;
      font-size: 0.8rem;
    }
  }
}

.map-badge {
  padding-bottom: 5px;
  padding-left: 0px;
  border-bottom: 0.5px dotted #23587e;
  width: 100%;
  margin-bottom: 2rem;
  color: #383838;
  text-transform: uppercase;
  font-weight: 600;
}

.el-badge {
  &__content {
    background-color: $corporateBlue;
    color: $white;
  }
}
</style>
